import { mdiClipboardAccountOutline } from '@mdi/js'

export default {
  title: 'Greeting',
  to: 'greeting-hod-list',
  icon: mdiClipboardAccountOutline,
  resource: 'GreetingHeadDepartment',
  action: 'read',
}
